module.exports = __webpack_public_path__ + "img/lianxi1.0691f8f7.png";